import React from 'react'
import { useStyles } from './styles'
import { usePutAway } from '../../Context/usePutAway'
import { putAwayActions } from '../../actions/putAwayBusiness'
import { WithoutResultsPanel } from '../../../UI'

/*
Copyright 2022-07-08 por Jorge Parrado Ecomsur Holding S.A ©
Detalle: Crea logica y acciones para buscar ot desconociendo ID
*/

export const SupplierButton = () => {
  const classes = useStyles()
  const { state } = usePutAway()
  const { suppliersUnknown, originsUnknown, unknownFilter } = state
  const { getWorkOrdersOrigin, getWorkOrdersSupplier } = putAwayActions()
  return (
    <div className={classes.container}>
      {unknownFilter === 3 &&
        suppliersUnknown.map((supplier) => (
          <div
            className={classes.supplierBtn}
            onClick={() =>
              getWorkOrdersSupplier(supplier.supplierId, supplier.supplierName)
            }
          >
            {supplier.supplierName}
          </div>
        ))}
      {unknownFilter === 4 &&
        originsUnknown.map((origin) => (
          <div
            className={classes.supplierBtn}
            onClick={() =>
              getWorkOrdersOrigin(
                origin.supplierOriginId,
                origin.supplierOriginName
              )
            }
          >
            {origin.supplierOriginName}
          </div>
        ))}
      {suppliersUnknown.length === 0 && unknownFilter === 3 && (
        <WithoutResultsPanel />
      )}
      {originsUnknown.length === 0 && unknownFilter === 4 && (
        <WithoutResultsPanel />
      )}
    </div>
  )
}
